import Checkbox from './checkbox';
import FormControlCheckbox from './form-control-checkbox';

export default Checkbox;
export { FormControlCheckbox };
